/* eslint-disable */
if (process.env.MOCK_ENABLE) {
  __webpack_public_path__ = '//localhost:8090/';
} else {
  __webpack_public_path__ = resolve(window.domainFromServer || window.__billing_domainFromServer__, 'fe-billing-opc-V3/');
}

// window.campaignFlags.enablePhoneValidation = true;

function resolve(a, b) {
  if (!a) {
    return ''
  }
  if (a[a.length - 1] === '/') {
    return a + b
  } else {
    return a + '/' + b
  }
}
